import { ProductQueryParam } from '../../../globalTypes';
import addDays from 'date-fns/add_days';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import format from 'date-fns/format';
import isBefore from 'date-fns/is_before';
import parse from 'date-fns/parse';
import startOfToday from 'date-fns/start_of_today';
var ParamSanitizer = /** @class */ (function () {
    function ParamSanitizer() {
    }
    ParamSanitizer.sanitizeProductQuery = function (productQuery) {
        this.sanitizeAirlines(productQuery);
        this.sanitizeAirports(productQuery);
        this.sanitizeAirportGroups(productQuery);
        this.sanitizeExtras(productQuery);
        this.sanitizeFlightStops(productQuery);
        this.sanitizeHotelCategory(productQuery);
        this.sanitizeRoomViewCodes(productQuery);
        this.sanitizeOptions(productQuery);
        this.sanitizePrices(productQuery);
        this.sanitizeTravelDatesAndDuration(productQuery);
        this.sanitizePreferredDepartureDate(productQuery);
        this.sanitizeDepartureDays(productQuery);
        this.sanitizeFlightTimes(productQuery);
        this.sanitizeTravellers(productQuery);
        return productQuery;
    };
    ParamSanitizer.sanitizeProductOptions = function (productOptions) {
        this.sanitizeIgnoreOpenJaw(productOptions);
        return productOptions;
    };
    ParamSanitizer.sanitizeQuery = function (query) {
        this.sanitizePageIndex(query);
        this.sanitizePageSize(query);
        this.sanitizePageSort(query);
        this.sanitizeFlex(query);
        return query;
    };
    ParamSanitizer.sanitizeAirlines = function (productQuery) {
        var _this = this;
        var airlineCodes = productQuery.FLIGHT_AIRLINE_CODES;
        if (airlineCodes) {
            if (Array.isArray(airlineCodes)) {
                if (airlineCodes.length === 0) {
                    delete productQuery.FLIGHT_AIRLINE_CODES;
                }
                else {
                    productQuery.FLIGHT_AIRLINE_CODES = airlineCodes.filter(function (airlineCode) { return airlineCode.match(_this.airlineCodeRegex); });
                }
            }
            else if (!airlineCodes.match(this.airlineCodeRegex)) {
                delete productQuery.FLIGHT_AIRLINE_CODES;
            }
        }
        else {
            delete productQuery.FLIGHT_AIRLINE_CODES;
        }
    };
    ParamSanitizer.sanitizeAirports = function (productQuery) {
        var _this = this;
        var airportCodes = productQuery.FLIGHT_DEPARTURE_AIRPORT_CODES;
        if (airportCodes) {
            if (Array.isArray(airportCodes)) {
                if (airportCodes.length === 0) {
                    delete productQuery.FLIGHT_DEPARTURE_AIRPORT_CODES;
                }
                else {
                    productQuery.FLIGHT_DEPARTURE_AIRPORT_CODES = airportCodes.filter(function (airportCode) { return airportCode.match(_this.airportCodeRegex); });
                }
            }
            else if (!airportCodes.match(this.airportCodeRegex)) {
                delete productQuery.FLIGHT_DEPARTURE_AIRPORT_CODES;
            }
        }
        else {
            delete productQuery.FLIGHT_DEPARTURE_AIRPORT_CODES;
        }
    };
    ParamSanitizer.sanitizeAirportGroups = function (productQuery) {
        var airportGroups = productQuery.FLIGHT_DEPARTURE_AIRPORT_GROUPS;
        if (airportGroups) {
            if (Array.isArray(airportGroups)) {
                if (airportGroups.length === 0) {
                    delete productQuery.FLIGHT_DEPARTURE_AIRPORT_GROUPS;
                }
                else {
                    productQuery.FLIGHT_DEPARTURE_AIRPORT_GROUPS = airportGroups.filter(this.isAllowedAirportGroup);
                }
            }
            else if (!this.isAllowedAirportGroup(airportGroups)) {
                delete productQuery.FLIGHT_DEPARTURE_AIRPORT_GROUPS;
            }
        }
        else {
            delete productQuery.FLIGHT_DEPARTURE_AIRPORT_GROUPS;
        }
    };
    ParamSanitizer.sanitizeExtras = function (productQuery) {
        var extras = productQuery.EXTRAS;
        if (extras) {
            if (Array.isArray(extras)) {
                if (extras.length === 0) {
                    delete productQuery.EXTRAS;
                }
                else {
                    productQuery.EXTRAS = extras.filter(this.isAllowedExtra);
                }
            }
            else if (!this.isAllowedExtra(extras)) {
                delete productQuery.EXTRAS;
            }
        }
        else {
            delete productQuery.EXTRAS;
        }
    };
    ParamSanitizer.sanitizeFlightStops = function (productQuery) {
        var flightStops = productQuery.FLIGHT_STOP_OVER_MAX;
        if (flightStops === undefined || flightStops === null || !this.isAllowedFlightStop(flightStops)) {
            delete productQuery.FLIGHT_STOP_OVER_MAX;
        }
    };
    ParamSanitizer.sanitizeHotelCategory = function (productQuery) {
        var hotelCategory = productQuery.HOTEL_CATEGORY;
        if (hotelCategory === undefined || hotelCategory === null || !this.isAllowedHotelCategory(hotelCategory)) {
            delete productQuery.HOTEL_CATEGORY;
        }
    };
    ParamSanitizer.sanitizeRoomViewCodes = function (productQuery) {
        var roomViewCodes = productQuery.HOTEL_ROOM_VIEW_CODES;
        if (roomViewCodes) {
            if (Array.isArray(roomViewCodes)) {
                if (roomViewCodes.length === 0) {
                    delete productQuery.HOTEL_ROOM_VIEW_CODES;
                }
                else {
                    productQuery.HOTEL_ROOM_VIEW_CODES = roomViewCodes.filter(this.isAllowedRoomViewCode);
                }
            }
            else if (!this.isAllowedRoomViewCode(roomViewCodes)) {
                delete productQuery.HOTEL_ROOM_VIEW_CODES;
            }
        }
        else {
            delete productQuery.HOTEL_ROOM_VIEW_CODES;
        }
    };
    ParamSanitizer.sanitizeOptions = function (productQuery) {
        var options = productQuery.OPTIONS;
        if (options) {
            if (Array.isArray(options)) {
                if (options.length === 0) {
                    delete productQuery.OPTIONS;
                }
                else {
                    productQuery.OPTIONS = this.removeDuplicatesFromArray(options.filter(this.isAllowedOption));
                }
            }
            else if (!this.isAllowedOption(options)) {
                delete productQuery.OPTIONS;
            }
        }
        else {
            delete productQuery.OPTIONS;
        }
    };
    ParamSanitizer.sanitizePrices = function (productQuery) {
        var priceMax = productQuery.PRICE_MAX;
        if (priceMax === undefined || priceMax === null || !this.isAllowedPrice(priceMax)) {
            delete productQuery.PRICE_MAX;
        }
        var priceMin = productQuery.PRICE_MIN;
        if (priceMin === undefined || priceMin === null || !this.isAllowedPrice(priceMin)) {
            delete productQuery.PRICE_MIN;
        }
    };
    ParamSanitizer.sanitizeTravelDatesAndDuration = function (productQuery) {
        var departureDate = productQuery.TRAVEL_PERIOD_DEPARTURE_DATE;
        var returnDate = productQuery.TRAVEL_PERIOD_RETURN_DATE;
        var validDateRange = true;
        if (departureDate !== undefined && departureDate !== null) {
            if (!this.isAllowedDate(departureDate)) {
                delete productQuery.TRAVEL_PERIOD_DEPARTURE_DATE;
                validDateRange = false;
            }
            else {
                if (this.isTravelDatePast(departureDate)) {
                    departureDate = format(startOfToday(), 'YYYY-MM-DD');
                }
                productQuery.TRAVEL_PERIOD_DEPARTURE_DATE = format(parse(departureDate), 'YYYY-MM-DD');
            }
        }
        if (returnDate !== undefined && returnDate !== null) {
            if (!this.isAllowedDate(returnDate)) {
                delete productQuery.TRAVEL_PERIOD_RETURN_DATE;
                validDateRange = false;
            }
            else {
                if (this.isTravelDatePast(returnDate)) {
                    returnDate = format(addDays(startOfToday(), 90), 'YYYY-MM-DD');
                }
                productQuery.TRAVEL_PERIOD_RETURN_DATE = format(parse(returnDate), 'YYYY-MM-DD');
            }
        }
        var duration = productQuery.TRAVEL_PERIOD_DURATION;
        /*if(duration === undefined || duration === null || !this.isAllowedDuration(duration)){
            productQuery.TRAVEL_PERIOD_DURATION = 10608;
        }*/
        if (validDateRange) {
            var maxTravelDuration = differenceInCalendarDays(productQuery.TRAVEL_PERIOD_RETURN_DATE, productQuery.TRAVEL_PERIOD_DEPARTURE_DATE);
            if (maxTravelDuration > 99) {
                maxTravelDuration = 99;
            }
            var durationString = '' + duration;
            var durationMin = parseInt(durationString.substr(1, 2), 10);
            var durationMax = parseInt(durationString.substr(3, 2), 10);
            if (durationMin > maxTravelDuration || durationMax > maxTravelDuration) {
                var newDurationString = '1' + String('0' + maxTravelDuration).slice(-2) + '00';
                productQuery.TRAVEL_PERIOD_DURATION = +newDurationString;
            }
        }
        else {
            productQuery.TRAVEL_PERIOD_DURATION = 10000;
        }
    };
    ParamSanitizer.sanitizeDepartureDays = function (productQuery) {
        var departureDays = productQuery.TRAVEL_PERIOD_DEPARTURE_DAYS;
        if (departureDays) {
            if (Array.isArray(departureDays)) {
                if (departureDays.length === 0) {
                    delete productQuery.TRAVEL_PERIOD_DEPARTURE_DAYS;
                }
                else {
                    productQuery.TRAVEL_PERIOD_DEPARTURE_DAYS = departureDays.filter(this.isAllowedDepartureDay);
                }
            }
            else if (!this.isAllowedDepartureDay(departureDays)) {
                delete productQuery.TRAVEL_PERIOD_DEPARTURE_DAYS;
            }
        }
        else {
            delete productQuery.TRAVEL_PERIOD_DEPARTURE_DAYS;
        }
    };
    ParamSanitizer.sanitizeFlightTimes = function (productQuery) {
        this.sanitizeTimeAtField(productQuery, ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MIN);
        this.sanitizeTimeAtField(productQuery, ProductQueryParam.TRAVEL_PERIOD_DEPARTURE_TIME_MAX);
        this.sanitizeTimeAtField(productQuery, ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MIN);
        this.sanitizeTimeAtField(productQuery, ProductQueryParam.TRAVEL_PERIOD_RETURN_TIME_MAX);
    };
    ParamSanitizer.sanitizeTimeAtField = function (productQuery, fieldName) {
        var timeValue = productQuery[fieldName];
        if (timeValue === undefined || timeValue === null || !this.isAllowedTime(timeValue)) {
            delete productQuery[fieldName];
        }
    };
    ParamSanitizer.sanitizeTravellers = function (productQuery) {
        var travellersChildren = productQuery.TRAVELLERS_CHILDREN_AGE;
        if (travellersChildren) {
            if (Array.isArray(travellersChildren)) {
                if (travellersChildren.length === 0) {
                    delete productQuery.TRAVELLERS_CHILDREN_AGE;
                }
                else {
                    productQuery.TRAVELLERS_CHILDREN_AGE = travellersChildren.filter(this.isAllowedTravellersChildrenAge);
                }
            }
            else if (!this.isAllowedTravellersChildrenAge(travellersChildren)) {
                delete productQuery.TRAVELLERS_CHILDREN_AGE;
            }
        }
        else {
            delete productQuery.TRAVELLERS_CHILDREN_AGE;
        }
    };
    ParamSanitizer.sanitizeIgnoreOpenJaw = function (productOptions) {
        var ignoreOpenJaw = productOptions.PHUB_FLIGHT_IGNORE_OPEN_JAW;
        // tslint:disable-next-line:triple-equals
        if (ignoreOpenJaw == 'true' || ignoreOpenJaw == '1') {
            productOptions.PHUB_FLIGHT_IGNORE_OPEN_JAW = true;
            // tslint:disable-next-line:triple-equals
        }
        else if (ignoreOpenJaw == 'false' || ignoreOpenJaw == '0') {
            productOptions.PHUB_FLIGHT_IGNORE_OPEN_JAW = false;
        }
        else {
            delete productOptions.PHUB_FLIGHT_IGNORE_OPEN_JAW;
        }
    };
    ParamSanitizer.sanitizePageIndex = function (query) {
        var page = query.page;
        if (page === undefined || page === null || !this.isAllowedPageIndex(page)) {
            query.page = 0;
        }
    };
    ParamSanitizer.sanitizePageSize = function (query) {
        var size = query.size;
        if (size === undefined || size === null || !this.isAllowedPageSize(size)) {
            query.size = 10;
        }
    };
    ParamSanitizer.sanitizePageSort = function (query) {
        var sorting = query.sorting;
        if (sorting === undefined || sorting === null || !this.isAllowedPageSorting(sorting)) {
            query.sorting = 'price';
        }
    };
    ParamSanitizer.sanitizePreferredDepartureDate = function (query) {
        var preferredDepartureDate = query.preferredDepartureDate;
        if (preferredDepartureDate === undefined || preferredDepartureDate === null || !this.isAllowedDate(preferredDepartureDate)) {
            delete query.preferredDepartureDate;
        }
        else {
            query.preferredDepartureDate = format(parse(preferredDepartureDate), 'YYYY-MM-DD');
        }
    };
    ParamSanitizer.sanitizeFlex = function (query) {
        var flex = query.flex;
        if (flex === '1' || flex === 'true') {
            query.flex = true;
        }
        else {
            delete query.preferredDepartureDate;
        }
    };
    ParamSanitizer.isTravelDatePast = function (date) {
        return isBefore(date, startOfToday());
    };
    ParamSanitizer.removeDuplicatesFromArray = function (array) {
        if (array) {
            return array.filter(function (e, i, a) { return a.indexOf(e) === i; });
        }
        return array;
    };
    ParamSanitizer.airlineCodeRegex = /^[a-zA-Z0-9]{2,3}$/g;
    ParamSanitizer.airportCodeRegex = /^[a-zA-Z]{3}$/g;
    ParamSanitizer.extrasRegex = /^TR|RAIL_AND_FLY$/g;
    ParamSanitizer.roomViewCodeRegex = /^GT13-SEVI$/g;
    ParamSanitizer.dateRegex = /^([0-9]{4})-(1[0-2]|0[1-9])-(3[0-1]|0[1-9]|[1-2][0-9])$/g;
    ParamSanitizer.weekdayRegex = /^(MONDAY|TUESDAY|WEDNESDAY|THURSDAY|FRIDAY|SATURDAY|SUNDAY)$/g;
    ParamSanitizer.timeRegex = /^(([0-1][0-9]|2[0-3]):00)|23:59$/g;
    ParamSanitizer.pageSortingRegex = /^qualifier(1|2|3|8|14|16)DESC|price|hotelName|startDate|duration|name$/g;
    ParamSanitizer.isAllowedAirportGroup = function (airportGroup) { return +airportGroup >= 1000 && +airportGroup <= 1011; };
    ParamSanitizer.isAllowedExtra = function (extra) { return ('' + extra).match(ParamSanitizer.extrasRegex); };
    ParamSanitizer.isAllowedFlightStop = function (flightStop) { return +flightStop >= 0 && +flightStop <= 2; };
    ParamSanitizer.isAllowedHotelCategory = function (hotelCategory) { return +hotelCategory >= 3 && +hotelCategory <= 5; };
    ParamSanitizer.isAllowedRoomViewCode = function (roomViewCode) { return ('' + roomViewCode).match(ParamSanitizer.roomViewCodeRegex); };
    ParamSanitizer.isAllowedOption = function (option) { return +option >= 1000 && +option <= 9000 || +option >= 12000 && +option <= 12200; };
    ParamSanitizer.isAllowedPrice = function (price) { return +price >= 100 && +price <= 5900; };
    ParamSanitizer.isAllowedDate = function (date) { return ('' + date).match(ParamSanitizer.dateRegex); };
    ParamSanitizer.isAllowedDepartureDay = function (day) { return ('' + day).match(ParamSanitizer.weekdayRegex); };
    ParamSanitizer.isAllowedTime = function (day) { return ('' + day).match(ParamSanitizer.timeRegex); };
    ParamSanitizer.isAllowedDuration = function (duration) { return +duration >= 10000 && +duration <= 15600; };
    ParamSanitizer.isAllowedTravellersAdults = function (travellers) { return +travellers >= 1 && +travellers <= 10; };
    ParamSanitizer.isAllowedTravellersChildrenAge = function (childrenAge) { return +childrenAge >= 0 && +childrenAge <= 17; };
    ParamSanitizer.isAllowedPageIndex = function (pageIndex) { return +pageIndex >= 0 && +pageIndex <= 1000; };
    ParamSanitizer.isAllowedPageSize = function (pageSize) { return +pageSize === 10; };
    ParamSanitizer.isAllowedPageSorting = function (pageSorting) { return ('' + pageSorting).match(ParamSanitizer.pageSortingRegex); };
    return ParamSanitizer;
}());
export default ParamSanitizer;
